export function sortData(data) {
  const allItems = Object.keys(data).flatMap((state) => {
    const entry = data[state];

    if (Array.isArray(entry)) {
      return entry.map((item) => ({ ...item, state }));
    }
    if (typeof entry === "object" && entry !== null) {
      return [{ ...entry, state }];
    }
    return [];
  });

  allItems.sort((a, b) => {
    // 1) isNewAddition first
    if (a.isNewAddition !== b.isNewAddition) {
      return a.isNewAddition ? -1 : 1;
    }

    // 2) alphabetical state
    if (a.state !== b.state) {
      return a.state.localeCompare(b.state);
    }

    // 3) numeric classCode (if exists)
    return Number(a.classCode || 0) - Number(b.classCode || 0);
  });

  return allItems;
}
